import { OneWayInServiceUpsertDto } from 'src/api/v2';
import useServiceSubForm, { extractSubData } from '../use-service-sub-form';
import { useTranslation } from 'react-i18next';

export type ContactInfoFields = 'contactName' | 'contactEmail' | 'contactPhone' | 'sponsors';
export type ContactInfoData = Pick<OneWayInServiceUpsertDto, ContactInfoFields>;

const useContactInfoForm = ({ data, updateData, errors, setErrors }) => {
  const { t } = useTranslation('services');

  const extractContactInfoFields = (data: OneWayInServiceUpsertDto): ContactInfoData => {
    return extractSubData(data, ['contactName', 'contactEmail', 'contactPhone', 'sponsors']);
  };
  const contactInfoFields = extractContactInfoFields(data);
  const { form } = useServiceSubForm<ContactInfoData>(contactInfoFields, updateData, errors, setErrors);

  const rules: Partial<Record<keyof OneWayInServiceUpsertDto, any>> = {
    contactName: { required: t('contact.name.required') },
    contactEmail: { required: t('contact.email.required') },
    contactPhone: {
      required: t('contact.phone.required'),
      maxLength: { value: 15, message: t('contact.phone.maxLength') },
    },
    sponsors: {
      validate: () => {
        const sponsors = form.getValues('sponsors') || [];
        if (sponsors.length === 0) {
          return 'Vennligst legg til minst én oppdragsgiver';
        }
        return true;
      },
    },
  };

  const registerWithRules = (field: ContactInfoFields) => form.register(field, rules[field]);

  return { form, rules, registerWithRules };
};

export default useContactInfoForm;
